import React from 'react';
import { Modal } from '@/components';
import parse from 'html-react-parser';
import { Flex, BoxV2 as Box, Button } from 'portal-commons';

interface Props {
  open?: boolean;
  disabled?: boolean;
  title?: string;
  text: string;
  onClose: () => void;
  onSubmit: () => void;
}
const ConfirmDeleteModal: React.FC<Props> = ({
  open,
  disabled,
  title,
  text,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal open={open} testId="confirmDeleteModal">
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
        }}
      >
        {title && (
          <Box
            as="h2"
            sx={{ py: 's', fontSize: 'H600', fontWeight: 600, mb: 8 }}
          >
            {title}
          </Box>
        )}
        <Box
          as="p"
          sx={{ fontSize: 'H400', lineHeight: 1.25, textAlign: 'left' }}
        >
          {parse(text)}
        </Box>
      </Flex>
      <Flex
        sx={{
          columnGap: '18px',
          padding: '30px 0',
        }}
      >
        <Button
          variant="outline"
          onClick={onClose}
          data-testid="confirmDeleteModalCancelButton"
        >
          Cancel
        </Button>
        <Button
          disabled={disabled}
          onClick={onSubmit}
          data-testid="confirmDeleteModalSubmitButton"
        >
          Delete
        </Button>
      </Flex>
    </Modal>
  );
};

export default ConfirmDeleteModal;
